import Bare from 'components/Layout/Bare';
import Padded from 'components/Layout/Padded';
import Unpadded from 'components/Layout/Unpadded';

export const BareLayout = Bare;
export const UnpaddedLayout = Unpadded;

export default Padded;
